'use client'

import FooterContent from '@/components/FooterContent'
import { motion, useScroll, useTransform } from 'motion/react'
import { useEffect, useRef, useState } from 'react'

export default function Footer({ settings }) {
	const scrollerRef = useRef(null)
	const footerRef = useRef(null)
	const { scrollYProgress } = useScroll({
		target: scrollerRef,
		offset: ['start end', 'end end']
	})
	const opacity = useTransform(scrollYProgress, [0, 1], [0.5, 0])

	const [footerHeight, setFooterHeight] = useState(0)

	useEffect(() => {
		if (!footerRef?.current) return

		function updateFooterHeight() {
			setFooterHeight(footerRef?.current?.clientHeight)
		}
		updateFooterHeight()

		window.addEventListener('resize', updateFooterHeight)

		return () => window.removeEventListener('resize', updateFooterHeight)
	}, [footerRef?.current])

	return (
		<>
			<div ref={scrollerRef} className='absolute bottom-0 left-0 z-400 w-1' style={{ height: `${footerHeight}px` }} />

			<div ref={footerRef} className="sticky left-0 bottom-0 z-100">

				<FooterContent settings={settings} />

				<motion.div style={{ opacity: opacity }} className='absolute inset-0 bg-black pointer-events-none touch-none' />

			</div>
		</>
	)
}
